import { IconButtonStyledOutlined } from '@/components/common/iconButtonStyledOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Skeleton, Stack, Typography } from '@mui/material';
import React from 'react';
import {
  FLYOUT_BORDER_COLOR,
  FLYOUT_HEADER_BORDER,
  FLYOUT_HEADER_PADDING,
  FLYOUT_SUBTITLE_FONT_SIZE,
  FLYOUT_SUBTITLE_FONT_WEIGHT,
  FLYOUT_SUBTITLE_LINE_HEIGHT,
  FLYOUT_TITLE_FONT_SIZE,
  FLYOUT_TITLE_FONT_WEIGHT,
  FLYOUT_TITLE_LINE_HEIGHT,
} from '../constants';

interface FlyoutHeaderProps {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  onClose?: () => void;
  closeLabel?: string;
  isFetching?: boolean;
  actions?: React.ReactNode;
  titleHeading?: {
    id: string;
  };
}

const FlyoutHeader: React.FC<FlyoutHeaderProps> = ({
  title,
  subtitle,
  onClose,
  closeLabel,
  isFetching,
  actions,
  titleHeading,
}) => (
  <Stack
    p={FLYOUT_HEADER_PADDING}
    direction='row'
    alignItems='flex-start'
    border={FLYOUT_HEADER_BORDER}
    borderColor={FLYOUT_BORDER_COLOR}
  >
    <Stack
      flex={1}
      direction='column'
      gap={1.5}
    >
      <Stack direction='column'>
        {isFetching ? (
          <Skeleton
            width='60%'
            height={FLYOUT_SUBTITLE_LINE_HEIGHT}
            sx={{ fontSize: FLYOUT_SUBTITLE_FONT_SIZE }}
          />
        ) : (
          <Typography
            fontSize={FLYOUT_SUBTITLE_FONT_SIZE}
            fontWeight={FLYOUT_SUBTITLE_FONT_WEIGHT}
            lineHeight={FLYOUT_SUBTITLE_LINE_HEIGHT}
          >
            {subtitle}
          </Typography>
        )}
        {isFetching ? (
          <Skeleton
            width='80%'
            height={FLYOUT_TITLE_LINE_HEIGHT}
            sx={{ fontSize: FLYOUT_TITLE_FONT_SIZE }}
          />
        ) : (
          <Typography
            component={titleHeading ? 'h2' : 'div'}
            id={titleHeading?.id}
            tabIndex={titleHeading ? -1 : undefined}
            fontSize={FLYOUT_TITLE_FONT_SIZE}
            fontWeight={FLYOUT_TITLE_FONT_WEIGHT}
            lineHeight={FLYOUT_TITLE_LINE_HEIGHT}
          >
            {title}
          </Typography>
        )}
      </Stack>

      {actions ? <Box>{actions}</Box> : null}
    </Stack>

    {onClose ? (
      <IconButtonStyledOutlined
        aria-label={closeLabel}
        onClick={onClose}
      >
        <CloseIcon />
      </IconButtonStyledOutlined>
    ) : null}
  </Stack>
);

export default React.memo(FlyoutHeader);
